import { useLocation } from "react-router-dom";
import './404.css'

export default function FourNaughtFour(props) {
  const location = useLocation();
  return <div> 
    {/* This page is coming soon. We are working on the full version of our new site and will be back shortly.
    {location.pathname} */}

<div className="not-found-container">
      <h1 className="h1class">404</h1>
      <p className="pclass">Oops! Page not found</p>
      <p className="pclass"> The page you are looking for might be under construction or does not exist.</p>
      {/* <div className="image-placeholder"></div> */}
    </div>
 
      <div className="four_zero_four_bg">
       
      </div>
    
 
  </div>
}